export const LS_IS_JUST_SIGNED_IN_VALUE = '1';
